// extracted by mini-css-extract-plugin
module.exports = {"container":"spinnerDots_container__13E_P","dot":"spinnerDots_dot__b5sqv","wave":"spinnerDots_wave__1QzTy"};